import { render, staticRenderFns } from "./VisitControlMgBase.vue?vue&type=template&id=01997055&scoped=true"
import script from "./VisitControlMgBase.vue?vue&type=script&lang=js"
export * from "./VisitControlMgBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01997055",
  null
  
)

export default component.exports